import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { AddOutlined, Publish } from "@material-ui/icons"
import {
   getStorage,
   ref,
   uploadBytesResumable,
   getDownloadURL,
} from "firebase/storage"
import app from "../../firebase"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
import Checkbox from "../../components/Checkbox/Checkbox"
// Data
import { createProduct } from "../../redux/apiCalls"
// Styles
import {
   Container,
   Wrapper,
   Main,
   TitleWrapper,
   Title,
   StyledButton,
   Bottom,
   AddVariation,
   ButtonWrapper,
   ButtonContainer,
   Message,
} from "./NewProduct.styles"
import {
   ItemKey,
   ItemValue,
   InfoItem,
   CreateTitle,
   CreateLeft,
   CreateItem,
   StyledLabel,
   StyledInput,
   CreateRight,
} from "./NewProduct.styles"
import {
   StyledForm,
   StyledSelect,
   StyledOption,
   StyledTextArea,
   NestedObjects,
   NestedObject,
   Upload,
   UploadIcon,
   CreateImage,
} from "./NewProduct.styles"

const NewProduct = () => {
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const [errorMessage, setErrorMessage] = useState("")

   const eansArray = useSelector((state) =>
      state.product.products.map((product) =>
         product.variations.map((variation) => variation.ean),
      ),
   )
   let eans = []
   for (let i = 0; i < eansArray.length; i++) {
      eans = [...eans, ...eansArray[i]]
   }
   const [maxEan, setMaxEan] = useState(Math.max(...eans) + 1)

   const userTypes = ["optician", "distributor", "public"]
   const [productInputs, setProductInputs] = useState({
      desc: [
         { language: "en", text: "" },
         { language: "fr", text: "" },
      ],
   })
   const [variationsInputs, setVariationsInputs] = useState([
      {
         ean: maxEan,
         detailedColor: [
            { language: "en", text: "" },
            { language: "fr", text: "" },
         ],
      },
   ])
   const [pricesInputs, setPricesInputs] = useState([
      { userType: "optician" },
      { userType: "distributor" },
      { userType: "public" },
   ])

   const [latestChecked, setLatestChecked] = useState(true)
   const latestCheckChange = () => {
      setProductInputs((prev) => {
         return { ...prev, latest: !latestChecked }
      })
      setLatestChecked((current) => !current)
   }

   const [outCollectionChecked, setOutCollectionChecked] = useState(false)
   const outCollectionChange = () => {
      setProductInputs((prev) => {
         return { ...prev, outOfCollection: !outCollectionChecked }
      })
      setOutCollectionChecked((current) => !current)
   }

   const addVariation = () => {
      setVariationsInputs((current) => [
         ...current,
         {
            ean: maxEan + 1,
            detailedColor: [
               { language: "en", text: "" },
               { language: "fr", text: "" },
            ],
         },
      ])
      setMaxEan((current) => current + 1)
   }

   const removeVariation = (i) => {
      setVariationsInputs((current) => [
         ...current.slice(0, i),
         ...current.slice(i + 1),
      ])
   }

   const handleChange = (e) => {
      setProductInputs((prev) => {
         return { ...prev, [e.target.name]: e.target.value }
      })
   }

   const handleCategories = (e) => {
      let categories = []
      const options = e.target.options
      for (let i = 0; i < options.length; i++) {
         options[i].selected && categories.push(options[i].value)
      }
      setProductInputs((prev) => {
         return { ...prev, categories: categories }
      })
   }

   const handleDesc = (e, lang) => {
      e.preventDefault()
      let desc = []
      for (let i = 0; i < productInputs.desc.length; i++) {
         desc.push({ ...productInputs.desc[i] })
      }
      desc.find((item) => item.language === lang).text = e.target.value
      setProductInputs((prev) => {
         return { ...prev, desc: desc }
      })
   }

   const handleVariation = (e) => {
      const index = parseInt(e.target.name.split("_")[0])
      const name = e.target.name.split("_")[1]
      const value = e.target.value
      let variationsValues = variationsInputs
      variationsValues[index][name] = value
      setVariationsInputs([...variationsValues])
   }

   const handleDetailedColor = (e, index, lang) => {
      e.preventDefault()
      let variationsValues = [...variationsInputs]
      let variationsColors = []
      for (let i = 0; i < variationsValues[index].detailedColor.length; i++) {
         variationsColors.push({
            ...variationsValues[index].detailedColor[i],
         })
      }
      variationsColors.find((item) => item.language === lang).text =
         e.target.value
      variationsValues[index]["detailedColor"] = variationsColors
      setVariationsInputs([...variationsValues])
   }

   const handleImages = (e, colorTheme) => {
      e.preventDefault()
      const storage = getStorage(app)
      let storageRef

      const index = parseInt(e.target.name.split("_")[0])
      let variationsValues = variationsInputs
      if (colorTheme === "dark") {
         variationsValues[index]["imagesDark"] = []
      } else {
         variationsValues[index]["imagesLight"] = []
      }

      let files = Array.from(e.target.files)
      let fileName = ""
      const productFolder =
         productInputs.title?.replace(/\s+/g, "_").toLowerCase() || "default"

      for (let i = 0; i < files.length; i++) {
         if (files[i].name.includes("mp4")) {
            fileName =
               variationsValues[index].code + "_v" + i + "_" + colorTheme
         } else {
            fileName = variationsValues[index].code + "_" + i + "_" + colorTheme
         }
         storageRef = ref(storage, `Products/${productFolder}/${fileName}`)
         const uploadTask = uploadBytesResumable(storageRef, files[i])

         uploadTask.on(
            "state_changed",
            (snapshot) => {
               const progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100
               console.log("Upload is " + progress + "% done")
               switch (snapshot.state) {
                  case "paused":
                     console.log("Upload is paused")
                     break
                  case "running":
                     console.log("Upload is running")
                     break
                  default:
               }
            },
            (error) => {
               console.log(error)
            },
            () => {
               getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                  console.log("File available at", downloadURL)
                  if (colorTheme === "dark") {
                     variationsValues[index]["imagesDark"].push(downloadURL)
                     variationsValues[index]["imagesDark"].sort()
                  } else {
                     variationsValues[index]["imagesLight"].push(downloadURL)
                     variationsValues[index]["imagesLight"].sort()
                  }
               })
            },
         )
      }
      setVariationsInputs([...variationsValues])
   }

   const handlePrice = (e) => {
      const index = parseInt(e.target.name.split("_")[0])
      const name = e.target.name.split("_")[1]
      const value = e.target.value
      let pricesValues = pricesInputs
      pricesValues[index][name] = value
      setPricesInputs([...pricesValues])
   }

   const handleSubmit = async (e) => {
      e.preventDefault()
      const product = {
         ...productInputs,
         variations: variationsInputs,
         prices: pricesInputs,
      }
      const res = await createProduct(product, dispatch)
      if (res === "success") {
         navigate("/products")
      } else {
         setErrorMessage(res.message)
      }
   }

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Create Product</Title>
               </TitleWrapper>
               <Bottom>
                  <CreateTitle>New Product</CreateTitle>
                  <StyledForm>
                     <CreateLeft>
                        <CreateItem>
                           <StyledLabel>Product name</StyledLabel>
                           <StyledInput
                              type="text"
                              name="title"
                              onChange={handleChange}
                           />
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>Categories</StyledLabel>
                           <StyledSelect
                              name="categories"
                              id="category"
                              multiple
                              onChange={handleCategories}
                           >
                              <StyledOption value="optical">
                                 Optical
                              </StyledOption>
                              <StyledOption value="sun">Sun</StyledOption>
                              <StyledOption value="accessory">
                                 Accessory
                              </StyledOption>
                           </StyledSelect>
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>Collection season</StyledLabel>
                           <StyledSelect
                              name="collectionSeason"
                              id="collectionSeason"
                              onChange={handleChange}
                           >
                              <StyledOption value=""></StyledOption>
                              <StyledOption value="s25">
                                 Fall Winter 2025
                              </StyledOption>
                              <StyledOption value="m26">
                                 Spring Summer 2026
                              </StyledOption>
                              <StyledOption value="s26">
                                 Fall Winter 2026
                              </StyledOption>
                           </StyledSelect>
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>Gender</StyledLabel>
                           <StyledSelect
                              name="gender"
                              id="gender"
                              onChange={handleChange}
                           >
                              <StyledOption value=""></StyledOption>
                              <StyledOption value="f">Female</StyledOption>
                              <StyledOption value="m">Male</StyledOption>
                              <StyledOption value="u">Unisex</StyledOption>
                           </StyledSelect>
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>Material</StyledLabel>
                           <StyledSelect
                              name="material"
                              id="material"
                              onChange={handleChange}
                           >
                              <StyledOption value=""></StyledOption>
                              <StyledOption value="acetate">
                                 Acetate
                              </StyledOption>
                              <StyledOption value="metal">Metal</StyledOption>
                              <StyledOption value="combined">
                                 Combined
                              </StyledOption>
                           </StyledSelect>
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>Shape</StyledLabel>
                           <StyledSelect
                              name="shape"
                              id="shape"
                              onChange={handleChange}
                           >
                              <StyledOption value=""></StyledOption>
                              <StyledOption value="square">
                                 Squared
                              </StyledOption>
                              <StyledOption value="panto">Panto</StyledOption>
                              <StyledOption value="butterfly">
                                 Butterfly
                              </StyledOption>
                              <StyledOption value="round">Round</StyledOption>
                              <StyledOption value="oval">Oval</StyledOption>
                              <StyledOption value="aviator">
                                 Aviator
                              </StyledOption>
                              <StyledOption value="hexagon">
                                 Hexagonal
                              </StyledOption>
                           </StyledSelect>
                        </CreateItem>
                     </CreateLeft>
                     <CreateLeft>
                        <CreateItem>
                           <StyledLabel>Lens width</StyledLabel>
                           <StyledInput
                              type="number"
                              name="lensWidth"
                              onChange={handleChange}
                           />
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>Lens height</StyledLabel>
                           <StyledInput
                              type="number"
                              name="lensHeight"
                              onChange={handleChange}
                           />
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>Nose</StyledLabel>
                           <StyledInput
                              type="number"
                              name="nose"
                              onChange={handleChange}
                           />
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>Temple length</StyledLabel>
                           <StyledInput
                              type="number"
                              name="templeLength"
                              onChange={handleChange}
                           />
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>Total width</StyledLabel>
                           <StyledInput
                              type="number"
                              name="totalWidth"
                              onChange={handleChange}
                           />
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>Size</StyledLabel>
                           <StyledSelect
                              name="size"
                              id="size"
                              onChange={handleChange}
                           >
                              <StyledOption value=""></StyledOption>
                              <StyledOption value="1">S</StyledOption>
                              <StyledOption value="2">M</StyledOption>
                              <StyledOption value="3">L</StyledOption>
                              <StyledOption value="4">XL</StyledOption>
                           </StyledSelect>
                        </CreateItem>
                     </CreateLeft>
                     <CreateRight>
                        <CreateItem>
                           <StyledLabel>Description EN</StyledLabel>
                           <StyledTextArea
                              onChange={(e) => handleDesc(e, "en")}
                           />
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>Description FR</StyledLabel>
                           <StyledTextArea
                              onChange={(e) => handleDesc(e, "fr")}
                           />
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>
                              <Checkbox
                                 checked={latestChecked}
                                 onChange={latestCheckChange}
                              />
                              Latest
                           </StyledLabel>
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>
                              <Checkbox
                                 checked={outCollectionChecked}
                                 onChange={outCollectionChange}
                              />
                              Out of collection
                           </StyledLabel>
                        </CreateItem>
                        <CreateItem>
                           <StyledLabel>Ranking</StyledLabel>
                           <StyledInput
                              type="number"
                              name="ranking"
                              onChange={handleChange}
                           />
                        </CreateItem>
                     </CreateRight>
                  </StyledForm>
               </Bottom>
               <NestedObjects>
                  {variationsInputs.map((item, index) => (
                     <NestedObject key={index}>
                        <StyledForm>
                           <CreateLeft>
                              <CreateItem>
                                 <StyledLabel>Variation code</StyledLabel>
                                 <StyledInput
                                    type="text"
                                    name={`${index}_code`}
                                    onChange={handleVariation}
                                 />
                              </CreateItem>
                              <CreateItem>
                                 <StyledLabel>Main Color</StyledLabel>
                                 <StyledSelect
                                    name={`${index}_mainColor`}
                                    id="mainColor"
                                    onChange={handleVariation}
                                 >
                                    <StyledOption value=""></StyledOption>
                                    <StyledOption value="black">
                                       Noir
                                    </StyledOption>
                                    <StyledOption value="crystal">
                                       Cristal
                                    </StyledOption>
                                    <StyledOption value="goldyellow">
                                       Or jaune
                                    </StyledOption>
                                    <StyledOption value="goldpink">
                                       Or rose
                                    </StyledOption>
                                    <StyledOption value="silver">
                                       Argent
                                    </StyledOption>
                                    <StyledOption value="turtle">
                                       Écaille
                                    </StyledOption>
                                    <StyledOption value="blue">
                                       Bleu
                                    </StyledOption>
                                    <StyledOption value="red">
                                       Rouge
                                    </StyledOption>
                                    <StyledOption value="green">
                                       Vert
                                    </StyledOption>
                                    <StyledOption value="grey">
                                       Gris
                                    </StyledOption>
                                    <StyledOption value="orange">
                                       Orange
                                    </StyledOption>
                                    <StyledOption value="yellow">
                                       Jaune
                                    </StyledOption>
                                    <StyledOption value="purple">
                                       Violet
                                    </StyledOption>
                                    <StyledOption value="pink">
                                       Rose
                                    </StyledOption>
                                    <StyledOption value="brown">
                                       Marron
                                    </StyledOption>
                                    <StyledOption value="panther">
                                       Panthère
                                    </StyledOption>
                                    <StyledOption value="ruthenium">
                                       Ruthénium
                                    </StyledOption>
                                    <StyledOption value="white">
                                       Blanc
                                    </StyledOption>
                                 </StyledSelect>
                              </CreateItem>
                              <CreateItem>
                                 <StyledLabel>Second Color</StyledLabel>
                                 <StyledSelect
                                    name={`${index}_secondColor`}
                                    id="secondColor"
                                    onChange={handleVariation}
                                 >
                                    <StyledOption value=""></StyledOption>
                                    <StyledOption value="black">
                                       Noir
                                    </StyledOption>
                                    <StyledOption value="crystal">
                                       Cristal
                                    </StyledOption>
                                    <StyledOption value="goldyellow">
                                       Or jaune
                                    </StyledOption>
                                    <StyledOption value="goldpink">
                                       Or rose
                                    </StyledOption>
                                    <StyledOption value="silver">
                                       Argent
                                    </StyledOption>
                                    <StyledOption value="turtle">
                                       Écaille
                                    </StyledOption>
                                    <StyledOption value="blue">
                                       Bleu
                                    </StyledOption>
                                    <StyledOption value="red">
                                       Rouge
                                    </StyledOption>
                                    <StyledOption value="green">
                                       Vert
                                    </StyledOption>
                                    <StyledOption value="grey">
                                       Gris
                                    </StyledOption>
                                    <StyledOption value="orange">
                                       Orange
                                    </StyledOption>
                                    <StyledOption value="yellow">
                                       Jaune
                                    </StyledOption>
                                    <StyledOption value="purple">
                                       Violet
                                    </StyledOption>
                                    <StyledOption value="pink">
                                       Rose
                                    </StyledOption>
                                    <StyledOption value="brown">
                                       Marron
                                    </StyledOption>
                                    <StyledOption value="panther">
                                       Panthère
                                    </StyledOption>
                                    <StyledOption value="ruthenium">
                                       Ruthénium
                                    </StyledOption>
                                    <StyledOption value="white">
                                       Blanc
                                    </StyledOption>
                                 </StyledSelect>
                              </CreateItem>
                              <CreateItem>
                                 <StyledLabel>Detailed Color EN</StyledLabel>
                                 <StyledInput
                                    type="text"
                                    onChange={(e) =>
                                       handleDetailedColor(e, index, "en")
                                    }
                                 />
                              </CreateItem>
                              <CreateItem>
                                 <StyledLabel>Detailed Color FR</StyledLabel>
                                 <StyledInput
                                    type="text"
                                    onChange={(e) =>
                                       handleDetailedColor(e, index, "fr")
                                    }
                                 />
                              </CreateItem>
                              <CreateItem>
                                 <StyledLabel>EAN13</StyledLabel>
                                 <StyledInput
                                    type="text"
                                    name={`${index}_ean`}
                                    value={item.ean || maxEan}
                                    onChange={handleVariation}
                                 />
                              </CreateItem>
                              <CreateItem>
                                 <StyledLabel>Inventory</StyledLabel>
                                 <StyledInput
                                    type="number"
                                    name={`${index}_inventory`}
                                    onChange={handleVariation}
                                 />
                              </CreateItem>
                              <CreateItem>
                                 <StyledLabel>Collection season</StyledLabel>
                                 <StyledSelect
                                    name={`${index}_collectionSeason`}
                                    id="collectionSeason"
                                    onChange={handleVariation}
                                 >
                                    <StyledOption value=""></StyledOption>
                                    <StyledOption value="s25">
                                       Fall Winter 2025
                                    </StyledOption>
                                    <StyledOption value="m26">
                                       Spring Summer 2026
                                    </StyledOption>
                                    <StyledOption value="s26">
                                       Fall Winter 2026
                                    </StyledOption>
                                 </StyledSelect>
                              </CreateItem>
                              <CreateItem>
                                 <StyledLabel>Images for Dark Mode</StyledLabel>
                                 <Upload>
                                    {variationsInputs[index].imagesDark?.map(
                                       (img) => (
                                          <CreateImage key={img} src={img} />
                                       ),
                                    )}
                                    <StyledLabel
                                       htmlFor={`${index}_dark_files`}
                                    >
                                       <UploadIcon>
                                          <Publish />
                                       </UploadIcon>
                                    </StyledLabel>
                                    <StyledInput
                                       type="file"
                                       id={`${index}_dark_files`}
                                       name={`${index}_dark_files`}
                                       style={{ display: "none" }}
                                       multiple
                                       onChange={(e) => handleImages(e, "dark")}
                                    />
                                 </Upload>
                              </CreateItem>
                              <CreateItem>
                                 <StyledLabel>
                                    Images for Light Mode
                                 </StyledLabel>
                                 <Upload>
                                    {variationsInputs[index].imagesLight?.map(
                                       (img) => (
                                          <CreateImage key={img} src={img} />
                                       ),
                                    )}
                                    <StyledLabel
                                       htmlFor={`${index}_light_files`}
                                    >
                                       <UploadIcon>
                                          <Publish />
                                       </UploadIcon>
                                    </StyledLabel>
                                    <StyledInput
                                       type="file"
                                       id={`${index}_light_files`}
                                       name={`${index}_light_files`}
                                       style={{ display: "none" }}
                                       multiple
                                       onChange={(e) =>
                                          handleImages(e, "light")
                                       }
                                    />
                                 </Upload>
                              </CreateItem>
                           </CreateLeft>
                        </StyledForm>
                        <StyledButton onClick={() => removeVariation(index)}>
                           Delete
                        </StyledButton>
                     </NestedObject>
                  ))}
                  <AddVariation onClick={() => addVariation()}>
                     <AddOutlined fontSize="large" />
                  </AddVariation>
               </NestedObjects>
               <NestedObjects>
                  {userTypes.map((userType, index) => (
                     <NestedObject type="price" key={index}>
                        <InfoItem>
                           <ItemKey>User Type:</ItemKey>
                           <ItemValue>{userType}</ItemValue>
                        </InfoItem>
                        <StyledForm>
                           <CreateLeft>
                              <CreateItem>
                                 <StyledLabel>Currency</StyledLabel>
                                 <StyledSelect
                                    name={`${index}_currency`}
                                    id="currency"
                                    defaultValue="eur"
                                    onChange={handlePrice}
                                 >
                                    <StyledOption value=""></StyledOption>
                                    <StyledOption value="eur">EUR</StyledOption>
                                    <StyledOption value="usd">USD</StyledOption>
                                 </StyledSelect>
                              </CreateItem>
                              <CreateItem>
                                 <StyledLabel>Beginning Date</StyledLabel>
                                 <StyledInput
                                    type="date"
                                    name={`${index}_beginningDate`}
                                    defaultValue="2025-01-01"
                                    onChange={handlePrice}
                                 />
                              </CreateItem>
                              <CreateItem>
                                 <StyledLabel>Ending Date</StyledLabel>
                                 <StyledInput
                                    type="date"
                                    name={`${index}_endingDate`}
                                    defaultValue="2099-12-31"
                                    onChange={handlePrice}
                                 />
                              </CreateItem>
                              <CreateItem>
                                 <StyledLabel>Price</StyledLabel>
                                 <StyledInput
                                    type="number"
                                    name={`${index}_price`}
                                    onChange={handlePrice}
                                 />
                              </CreateItem>
                           </CreateLeft>
                        </StyledForm>
                     </NestedObject>
                  ))}
               </NestedObjects>
               <ButtonContainer>
                  <ButtonWrapper>
                     <StyledButton onClick={handleSubmit}>Create</StyledButton>
                     <Message>{errorMessage}</Message>
                  </ButtonWrapper>
               </ButtonContainer>
            </Main>
         </Container>
      </>
   )
}

export default NewProduct
